<div class="hide-acc">
  <div class="container-box mobileView">
    <h1>Dashboard</h1> <!-- AT&T Business Console--> 
    <div class="alert valign-children-middle" *ngIf="errorMsg.length > 0">
      <div class="alert-error" aria-label="Alert.">
        <i class="icon-badgealert" aria-hidden="true"></i>
      </div>
      <div>
        <span>{{ errorMsg }}</span>
      </div>
    </div>
    <div class="dashboard-error-box" *ngIf="errMsgDisplay">
      <div class="alert valign-children-middle">
        <div class="alert-error" role="img" aria-label="Alert">
          <i class="icon-badgealert"></i>
        </div>
        <div>
          <span>We are still finalizing your account set up for
            <span>{{ activeFanId }}</span>. Newly enrolled devices will be displayed after enrollment is
            completed. This could take up to 1 business day.
          </span>
        </div>
        <button class="close" (click)="errMsgDisplay = !errMsgDisplay" aria-label="Close"></button>
      </div>
    </div>
    <h2>Welcome, {{ user.firstName }} {{ user.lastName }}</h2>

    <!--ADDP section starts here&& hasAddpPermission-->
    <section *ngIf="dashboardData && hasAddpPermission" class="addp-dashboard-page">
      <div *ngIf="fanStatus">
        <p *ngIf="dashboardData.useMock">
          Scenarios for Demo:
          <select #scenarios (change)="initPage(scenarios.value)">
            <option value="0">Initial Signup</option>
            <option value="1">Signup In Progress</option>
            <option value="2">Error In Signup</option>
            <option value="3">Awaiting Setup</option>
            <option value="4">Setup In Progress</option>
            <option value="5">Setup Completed</option>
            <option value="6">Enrollment In Progress</option>
            <option value="7">Error In Enrollment</option>
            <option value="8">
              Multi Fan Enrolled / Apple Certificate not Installed
            </option>
            <option value="9">
              Single Fan Enrolled / Apple Certificate Expired
            </option>
            <option value="10">No Eligible Foundation Accounts</option>
          </select>
        </p>
        <!-- <h3 id="dashboardDataSubTitle">{{dashboardData.subTitle}}</h3> -->

        <div *ngIf="showData" class="row addp-dashboard-container" id="addp-dashboard-container">
          <div class="col-sm-12 col-md-4 col-md-size" *ngIf="
            isSingleABMFE == false && fanStatus.allFansInEligible !== true &&
              (fanStatus.initialSignupStatus !== 'Completed' ||
                (fanStatus.initialSignupStatus === 'Completed' &&
                  fanStatus.noOfFans > 1 &&
                  eligibleFanCount > 1))
            ">
            <div class="container fan-status-container">
              <div class="inside-container">
                <h4>{{ dashboardData.manageDeployment.title }}</h4>
                <!-- <h4 class="manageDeploymentMixedFans" *ngIf="manageDeploymentMixedFans">{{dashboardData.manageDeployment.subTitle}}</h4> -->
                <div *ngIf="
                    fanStatus.initialSignupStatus === 'Not Signed Up' &&
                    !processingFansFlag
                  ">
                  <div id="first-time-user-notification">
                    <p>{{ dashboardData.manageDeployment.firstTimeUser }}</p>
                  </div>
                  <div class="dashboard-button-container">
                    <button [disabled]="!hasAddpFullPermission" (click)="navigate('welcome')" class="btn btn-default"
                      [checkRole]="dashboardData.fieldPermissions.welcome" type="button">
                      {{ dashboardData.button.initialSignup }}
                    </button>
                  </div>
                </div>

                <div *ngIf="fanStatus.initialSignupStatus === 'Signed Up'">
                  <div id="first-time-user-notification">
                    <p>{{ dashboardData.manageDeployment.firstTimeUser }}</p>
                  </div>
                  <div>
                    <div class="donut-chart-container text-center">
                      <app-donut-chart [data]="chartData.accounts" [r]="chartRadius" [label]="chartLabel.accounts"
                        [stroke_width]="strokeWidth">
                      </app-donut-chart>
                    </div>
                    <div class="donut-chart-legend-container row">
                      <!-- <app-legend class="col-sm-6 col-md-6" [data]="legendData.accounts.left"></app-legend>
                      <app-legend class="col-sm-6 col-md-6" [data]="legendData.accounts.right"></app-legend> -->
                      <app-legend [data]="legendData.accounts"></app-legend>
                    </div>
                  </div>
                  <div *ngIf="
                      apiError == false &&
                      accountDetails.productCode === 'ADDPMDM'
                    ">
                    <div class="apple-cert text-center" *ngIf="this.appleInstalled">
                      <div class="text-center">
                        <i class="icon-alert iconNI" role="img" aria-label="Alert" *ngIf="
                            fanStatus.appleCertificate == 'Not Installed' ||
                            fanStatus.appleCertificate == 'Nearing expiration'
                          "></i>
                        <i class="icon-alert iconE" role="img" aria-label="Alert"
                          *ngIf="fanStatus.appleCertificate == 'Expired'"></i>
                        <i class="icon-alert iconP" role="img" aria-label="Alert"
                          *ngIf="fanStatus.appleCertificate == 'Processing'"></i>
                        <i class="icon-approval iconI" role="img" aria-label="Alert"
                          *ngIf="fanStatus.appleCertificate == 'Installed'"></i>
                        <a [checkRole]="
                            dashboardData.fieldPermissions.appleCertificate
                          " routerLink="/appleCertificate">{{ appleInstalled }}</a>
                      </div>
                    </div>
                  </div>

                  <div class="text-center remove-account" *ngIf="accountDetails.productCode === 'ADDPMDM'">
                    <a [checkRole]="
                        dashboardData.fieldPermissions.cancelParticipation
                      " routerLink="/cancelParticipation">{{ dashboardData.cancelParticipation }}</a>
                  </div>
                  <div class="text-center remove-account" *ngIf="accountDetails.productCode === 'ADDPZTE'">
                    <a [ngClass]="{'disable-link': disableRemoveLink}" [checkRole]="
                        dashboardData.fieldPermissions.cancelParticipation
                      " routerLink="/cancelParticipation/removeaccount">{{ dashboardData.cancelParticipation }}</a>
                  </div>
                  <div class="dashboard-button-container">
                    <div *ngIf="accountDetails.productCode === 'ADDPMDM'">
                      <button [disabled]="!hasAddpFullPermission" (click)="navigate('signup')" class="btn btn-default"
                        type="button" tabindex="0">
                        {{ dashboardData.button.manageFan }}
                      </button>
                    </div>
                    <div *ngIf="accountDetails.productCode === 'ADDPZTE'">
                      <button [disabled]="!hasAddpFullPermission" (click)="navigate('manageInventory')"
                        class="btn btn-default" type="button" tabindex="0">
                        {{ dashboardData.button.manageFan }}
                      </button>
                    </div>
                  </div>
                </div>
                <div *ngIf="
                    fanStatus.initialSignupStatus === 'Not Signed Up' &&
                    processingFansFlag
                  ">
                  <div id="first-time-user-notification">
                    <p>{{ dashboardData.manageDeployment.firstTimeUser }}</p>
                  </div>
                  <div>
                    <div class="donut-chart-container text-center">
                      <app-donut-chart [data]="chartData.accounts" [r]="chartRadius" [label]="chartLabel.accounts"
                        [stroke_width]="strokeWidth">
                      </app-donut-chart>
                    </div>
                    <div class="donut-chart-legend-container row">
                      <!-- <app-legend class="col-sm-6 col-md-6" [data]="legendData.accounts.left"></app-legend>
                      <app-legend class="col-sm-6 col-md-6" [data]="legendData.accounts.right"></app-legend> -->
                      <app-legend [data]="legendData.accounts"></app-legend>
                    </div>
                  </div>

                  <div class="text-center remove-account" *ngIf="accountDetails.productCode === 'ADDPMDM'">
                    <a [checkRole]="
                        dashboardData.fieldPermissions.cancelParticipation
                      " routerLink="/cancelParticipation">{{ dashboardData.cancelParticipation }}</a>
                  </div>
                  <div class="text-center remove-account" *ngIf="
                      accountDetails.productCode === 'ADDPZTE' &&
                      processingFansFlag
                    ">
                    <a [ngClass]="{'disable-link': disableRemoveLink}" [checkRole]="
                        dashboardData.fieldPermissions.cancelParticipation
                      " routerLink="/cancelParticipation/removeaccount">{{ dashboardData.cancelParticipation }}</a>
                  </div>
                  <div class="dashboard-button-container">
                    <div *ngIf="accountDetails.productCode === 'ADDPZTE'">
                      <button [disabled]="!hasAddpFullPermission" (click)="navigate('manageInventory')"
                        class="btn btn-default" type="button" tabindex="0">
                        {{ dashboardData.button.manageFan }}
                      </button>
                    </div>
                  </div>
                </div>

                <div *ngIf="fanStatus.initialSignupStatus === 'PROCESSING' && isSingleABMFE == false">
                  <p id="first-time-user-notification">
                    {{ dashboardData.manageDeployment.signUpProcess }}
                  </p>
                </div>

                <div *ngIf="fanStatus.initialSignupStatus === 'Error'">
                  <div *ngIf="fanStatus.initialSignupStatus === 'Error'" class="dashboard-error-box">
                    <div class="alert valign-children-middle">
                      <div class="alert-error" role="img" aria-label="Alert">
                        <i class="icon-badgealert"></i>
                      </div>
                      <div>
                        <span *ngIf="fanStatus.initialSignupStatus === 'Error'">{{ dashboardData.manageDeployment.error
                          }}</span>
                        <span *ngIf="fanStatus.deviceEnrolledStatus === 'Error'">{{ dashboardData.deviceInventory.error
                          }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="dashboard-button-container">
                    <button (click)="navigate('signup')" class="btn btn-default"
                      [checkRole]="dashboardData.fieldPermissions.signup" type="button">
                      {{ dashboardData.button.retrySignup }}
                    </button>
                  </div>
                </div>

                <div *ngIf="
                    fanStatus.initialSignupStatus === 'Completed' &&
                    chartData.accounts
                  ">
                  <p *ngIf="
                      fanStatus.deviceEnrolledStatus === 'Completed' ||
                      fanStatus.deviceEnrolledStatus === 'Future Enrollment'
                    ">
                    {{ dashboardData.manageDeployment.setupCompleteContent }}
                  </p>
                  <p *ngIf="
                      fanStatus.deviceEnrolledStatus !== 'Completed' &&
                      fanStatus.deviceEnrolledStatus !== 'Future Enrollment'
                    ">
                    {{ dashboardData.manageDeployment.setupCompleteContent }}
                  </p>
                  <div>
                    <div class="donut-chart-container text-center">
                      <app-donut-chart [data]="chartData.accounts" [r]="chartRadius" [label]="chartLabel.accounts"
                        [stroke_width]="strokeWidth">
                      </app-donut-chart>
                    </div>
                    <div class="donut-chart-legend-container row">
                      <!-- <app-legend class="col-sm-6 col-md-6" [data]="legendData.accounts.left"></app-legend>
                      <app-legend class="col-sm-6 col-md-6" [data]="legendData.accounts.right"></app-legend> -->
                      <app-legend [data]="legendData.accounts"></app-legend>
                    </div>
                  </div>
                  <div *ngIf="
                      apiError == false &&
                      accountDetails.productCode === 'ADDPMDM'
                    ">
                    <div class="apple-cert text-center" *ngIf="this.appleInstalled">
                      <div class="text-center">
                        <i class="icon-alert iconNI" role="img" aria-label="Alert" *ngIf="
                            fanStatus.appleCertificate == 'Not Installed' ||
                            fanStatus.appleCertificate == 'Nearing expiration'
                          "></i>
                        <i class="icon-alert iconE" role="img" aria-label="Alert"
                          *ngIf="fanStatus.appleCertificate == 'Expired'"></i>
                        <i class="icon-alert iconP" role="img" aria-label="Alert"
                          *ngIf="fanStatus.appleCertificate == 'Processing'"></i>
                        <i class="icon-approval iconI" role="img" aria-label="Alert"
                          *ngIf="fanStatus.appleCertificate == 'Installed'"></i>
                        <a [checkRole]="
                            dashboardData.fieldPermissions.appleCertificate
                          " routerLink="/appleCertificate">{{ appleInstalled }}</a>
                      </div>
                    </div>
                  </div>

                  <div class="text-center remove-account" *ngIf="accountDetails.productCode === 'ADDPMDM'">
                    <a [checkRole]="
                        dashboardData.fieldPermissions.cancelParticipation
                      " routerLink="/cancelParticipation">{{ dashboardData.cancelParticipation }}</a>
                  </div>
                  <div class="text-center remove-account" *ngIf="accountDetails.productCode === 'ADDPZTE'">
                    <a [ngClass]="{'disable-link': disableRemoveLink}" [checkRole]="
                        dashboardData.fieldPermissions.cancelParticipation
                      " routerLink="/cancelParticipation/removeaccount">{{ dashboardData.cancelParticipation }}</a>
                  </div>
                  <div class="dashboard-button-container">
                    <button (click)="navigate('manageInventory')" class="btn btn-default" type="button" tabindex="0">
                      {{ dashboardData.button.manageFan }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-12 col-md-4 col-md-size fd" *ngIf="isSingleABMFE == true">
            <div class="container device-status-container">
              <div class="inside-container">
                <h4>{{dashboardData.deviceInventory.title}}</h4>
                <div>
                  <p>
                    {{ dashboardData.deviceInventory.singleFanMsg}}
                  </p>
                  <div class="dashboard-button-container">
                    <button (click)="navigate('manageInventory/deviceInventory')" class="btn btn-default" type="button">
                      {{ dashboardData.button.manageDevice }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-12 col-md-4 col-md-size"
            *ngIf="fanStatus.initialSignupStatus === 'Completed' || (fanStatus.initialSignupStatus === 'Not Signed Up' && showDeviceInventoryIfNotSignedUp)">
            <div class="container device-status-container">
              <div class="inside-container">
                <h4>{{ dashboardData.deviceInventory.title }}</h4>

                <div *ngIf="
                    (fanStatus.deviceEnrolledStatus === 'Not Enrolled' &&
                    !processingFansFlag) && !showDeviceInventoryIfNotSignedUp
                  ">
                  <!-- <p class="initial-text">{{dashboardData.deviceInventory.enrolledDevice}}</p> -->
                  <p>
                    {{ dashboardData.deviceInventory.initialNotEnrolledDevice }}
                  </p>
                  <div class="dashboard-button-container">
                    <button (click)="navigate('manageInventory')" class="btn btn-default" type="button">
                      {{ dashboardData.button.enrolledDevice }}
                    </button>
                  </div>
                </div>

                <div *ngIf="fanStatus.deviceEnrolledStatus === 'PROCESSING'">
                  <!-- <p class="initial-text">{{dashboardData.deviceInventory.enrolledDevice}}</p> -->
                  <p>{{ dashboardData.deviceInventory.enrollmentProcess }}</p>
                </div>
                <div *ngIf="fanStatus.deviceEnrolledStatus === 'Error'">
                  <div *ngIf="fanStatus.deviceEnrolledStatus === 'Error'" class="dashboard-error-box">
                    <div class="alert valign-children-middle">
                      <div class="alert-error" role="img" aria-label="Error">
                        <i class="icon-badgealert"></i>
                      </div>
                      <div>
                        <!-- <h4>{{dashboardData.note}}</h4> -->
                        <span *ngIf="fanStatus.initialSignupStatus === 'Error'">{{ dashboardData.manageDeployment.error
                          }}</span>
                        <span *ngIf="fanStatus.deviceEnrolledStatus === 'Error'">{{ dashboardData.deviceInventory.error
                          }}</span>
                      </div>
                    </div>
                  </div>

                  <!--    <p class='device-hide initial-text'>{{dashboardData.deviceInventory.enrolledDevice}}</p>
                <p>{{dashboardData.deviceInventory.deviceState}}</p>
              <div class="donut-chart-container text-center">
                  <app-donut-chart [data]="chartData.error" [r]='chartRadius' [error]=true [label]="chartLabel.error" [stroke_width]='strokeWidth'>
                  </app-donut-chart>
                </div> -->
                  <div class="dashboard-button-container">
                    <button (click)="navigate('manageInventory')" class="btn btn-default" type="button">
                      {{ dashboardData.button.retryDeviceSetup }}
                    </button>
                  </div>
                </div>
                <div *ngIf="
                    fanStatus.deviceEnrolledStatus === 'Completed' || showDeviceInventoryIfNotSignedUp || 
                    (fanStatus.deviceEnrolledStatus === 'Future Enrollment' &&
                      chartData.devices)
                  ">
                  <!-- <p class="initial-text">{{dashboardData.deviceInventory.enrolledDevice}}</p> -->
                  <div id="first-time-user-notification">
                    <p>{{ dashboardData.deviceInventory.setupOemCompleted }}</p>
                  </div>
                  <div>
                    <div class="donut-chart-container text-center">
                      <app-donut-chart [data]="chartData.devices" [r]="chartRadius" [label]="chartLabel.devices"
                        [stroke_width]="strokeWidth">
                      </app-donut-chart>
                    </div>
                    <div class="donut-chart-legend-container row">
                      <app-legend [data]="legendData.devices"></app-legend>
                      <!-- <app-legend class="col-sm-6 col-md-6" [data]="legendData.devices.left"></app-legend>
                      <app-legend class="col-sm-6 col-md-6" [data]="legendData.devices.right"></app-legend> -->
                    </div>
                  </div>
                  <div *ngIf="
                      apiError == false &&
                      accountDetails.productCode === 'ADDPMDM'
                    ">
                    <div class="apple-cert text-center" *ngIf="this.appleInstalled && fanStatus.noOfFans === 1">
                      <div class="text-center">
                        <i class="icon-alert iconNI" role="img" aria-label="Alert" *ngIf="
                            fanStatus.appleCertificate == 'Not Installed' ||
                            fanStatus.appleCertificate == 'Nearing expiration'
                          "></i>
                        <i class="icon-alert iconE" role="img" aria-label="Alert"
                          *ngIf="fanStatus.appleCertificate == 'Expired'"></i>
                        <i class="icon-alert iconP" role="img" aria-label="Alert"
                          *ngIf="fanStatus.appleCertificate == 'Processing'"></i>
                        <i class="icon-approval iconI" role="img" aria-label="Alert"
                          *ngIf="fanStatus.appleCertificate == 'Installed'"></i>
                        <a [checkRole]="
                            dashboardData.fieldPermissions.appleCertificate
                          " routerLink="/appleCertificate">{{ appleInstalled }}</a>
                      </div>
                    </div>
                  </div>
                  <div class="text-center remove-account" *ngIf="
                      accountDetails.productCode === 'ADDPMDM' &&
                      fanStatus.noOfFans === 1
                    ">
                    <a [checkRole]="
                        dashboardData.fieldPermissions.cancelParticipation
                      " routerLink="/cancelParticipation">{{ dashboardData.cancelParticipation }}</a>
                  </div>
                  <div class="text-center remove-account" style="margin-bottom: 0px !important" *ngIf="
                      accountDetails.productCode === 'ADDPZTE' &&
                      fanStatus.noOfFans === 1
                    ">
                    <a [checkRole]="
                        dashboardData.fieldPermissions.cancelParticipation
                      " routerLink="/cancelParticipation/removeaccount">{{ dashboardData.cancelParticipation }}</a>
                  </div>
                  <div class="dashboard-button-container" *ngIf="fanStatus.noOfFans > 1">
                    <button (click)="navigate('manageInventory')" class="btn btn-default" type="button" tabindex="0">
                      {{ dashboardData.button.viewDetail }}
                    </button>
                  </div>
                  <div class="dashboard-button-container" *ngIf="fanStatus.noOfFans <= 1">
                    <button (click)="navigate('manageInventory/deviceInventory')" class="btn btn-default" type="button">
                      {{ dashboardData.button.manageDevice }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-4 col-md-size" *ngIf="fanStatus.initialSignupStatus === 'Completed'">
            <div class="container report-container" *ngIf="accountDetails.productCode === 'ADDPMDM'">
              <div class="inside-container">
                <h4>{{ dashboardData.report.title }}</h4>
                <!-- <p class='device-hide initial-text'>{{dashboardData.report.downloadUserReport}}</p> -->
                <p>{{ dashboardData.report.content }}</p>
                <div class="dashboard-button-container">
                  <button title="Opens a new dialog." [checkRole]="dashboardData.fieldPermissions.report"
                    (click)="navigate('/reports')" class="btn btn-default" type="button">
                    {{ dashboardData.button.getReport }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-4 col-md-size" *ngIf="fanStatus.allFansInEligible === true">
            <div class="container fan-status-container">
              <div class="inside-container">
                <ng-container *ngIf="envPortal !== 'fnabc'; else fnInEligibelTemplate">
                  <!-- <div *ngIf = showNotEligible>
                    <h4>{{dashboardData.manageDeployment.ineligibleTitle}}</h4>
                    <p>{{dashboardData.manageDeployment.ineligibleContent}}</p>
                  </div>
                  <div *ngIf = showUnknown>
                    <h4>Unable to access Accounts</h4>
                    <p>We are unable to access your account at this time. Please try again later.</p>
                  </div> -->
                  <h4>{{ dashboardData.manageDeployment.ineligibleTitle }}</h4>
                  <p>{{ dashboardData.manageDeployment.ineligibleContent }}</p>
                </ng-container>
                <ng-template #fnInEligibelTemplate>
                  <!-- <div *ngIf = showNotEligible>
                    <h4>{{dashboardData.manageDeployment[ envPortal ].ineligibleTitle}}</h4>
                    <p>{{dashboardData.manageDeployment[ envPortal ].ineligibleContent}}</p>
                  </div>
                  <div *ngIf = showUnknown>
                    <h4>{{dashboardData.manageDeployment[ envPortal ].unknownTitle}}</h4>
                    <p>{{dashboardData.manageDeployment[ envPortal ].unknownContent}}</p>
                  </div> -->
                  <h4>
                    {{
                    dashboardData.manageDeployment[envPortal].ineligibleTitle
                    }}
                  </h4>
                  <p>
                    {{
                    dashboardData.manageDeployment[envPortal]
                    .ineligibleContent
                    }}
                  </p>
                </ng-template>
                <!-- commenting as a part of US-1367 -->
                <!-- <div class="dashboard-button-container">
                  <button (click)="navigate('learn')" class="btn btn-default" type="button">
                    {{ dashboardData.button.learnMore }}
                  </button>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div *ngIf="user && permissionLevelMessage" class="msg-content">
      <span>{{ permissionLevelMessage }}</span>
    </div>
    <div class="clearfix"></div>
  </div>
</div>
<div *ngIf="showReportPopup">
  <app-modal [showModal]="showReportPopup" [modalClass]="modalClass">
    <app-report [modalPopupObject]="confirmModalPopup" [triggerElement]="eventEmit"
      (modalOutput)="closeReportPopup($event)">
    </app-report>
  </app-modal>
</div>